import React from "react";
import { FaStore, FaCheckCircle, FaUserTimes, FaPercentage } from "react-icons/fa";

const Cards = ({ totalShops = 0, activeShops = 0 }) => {
  const inactive   = totalShops - activeShops;
  const activeRate = totalShops > 0 ? Math.round((activeShops / totalShops) * 100) : 0;

  const cards = [
    {
      label:"Total Shops",    value:totalShops,   icon:<FaStore />,
      bg:"linear-gradient(135deg,#0B2E33 0%,#1a4a52 100%)",
      glow:"rgba(11,46,51,.3)", badge:"Registered", note:"All registered",
    },
    {
      label:"Active Shops",   value:activeShops,  icon:<FaCheckCircle />,
      bg:"linear-gradient(135deg,#4F7C82 0%,#0B2E33 100%)",
      glow:"rgba(79,124,130,.28)", badge:"Online", note:"Currently active",
    },
    {
      label:"Inactive Shops", value:inactive,     icon:<FaUserTimes />,
      bg:"linear-gradient(135deg,#931B5B 0%,#6b1443 100%)",
      glow:"rgba(147,27,91,.28)", badge:"Offline", note:"Needs attention",
    },
    {
      label:"Active Rate",    value:`${activeRate}%`, icon:<FaPercentage />,
      bg:"linear-gradient(135deg,#5c1238 0%,#931B5B 100%)",
      glow:"rgba(92,18,56,.28)", badge:"KPI", note:"Perf Index",
    },
  ];

  return (
    <>
      <style>{`
        @keyframes sc-up { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        .sc-grid {
          display:grid; grid-template-columns:repeat(4,1fr); gap:12px;
        }
        .sc-card {
          border-radius:12px; padding:16px;
          color:#fff; position:relative; overflow:hidden;
          transition:transform .25s ease,box-shadow .25s ease;
          animation:sc-up .45s ease both;
          display:flex; flex-direction:column; gap:8px; cursor:default;
          height: 125px; justify-content: space-between;
        }
        .sc-card:hover { transform:translateY(-3px); }
        .sc-card::after {
          content:''; position:absolute; bottom:-15px; right:-15px;
          width:70px; height:70px; border-radius:50%;
          background:rgba(255,255,255,.07); pointer-events:none;
        }
        .sc-top   { display:flex; align-items:center; justify-content:space-between; }
        .sc-badge {
          font-size:8px; font-weight:700; letter-spacing:1px;
          text-transform:uppercase; padding:2px 8px; border-radius:20px;
          background:rgba(255,255,255,.18); color:#fff;
        }
        .sc-icon {
          width:34px; height:34px; border-radius:10px;
          background:rgba(255,255,255,.16);
          display:flex; align-items:center; justify-content:center;
          font-size:16px; border:1px solid rgba(255,255,255,.2); flex-shrink:0;
        }
        .sc-value  { font-size:28px; font-weight:800; line-height:1; letter-spacing:-0.5px; }
        .sc-bottom { border-top:1px solid rgba(255,255,255,.1); padding-top:6px; display: flex; justify-content: space-between; align-items: center; }
        .sc-label  { font-size:12px; font-weight:600; color:rgba(255,255,255,.9); }
        .sc-note   { font-size:10px; color:rgba(255,255,255,.5); }

        @media(max-width:1100px){ .sc-grid{ grid-template-columns:repeat(2,1fr); } .sc-card { height: auto; min-height: 100px; } }
        @media(max-width:560px) { .sc-grid{ grid-template-columns:1fr; } }
      `}</style>

      <div className="sc-grid">
        {cards.map((c, i) => (
          <div
            key={i} className="sc-card"
            style={{ background:c.bg, boxShadow:`0 6px 16px ${c.glow}`, animationDelay:`${i*.05}s` }}
          >
            <div className="sc-top">
              <span className="sc-badge">{c.badge}</span>
              <div className="sc-icon">{c.icon}</div>
            </div>
            <div className="sc-value">{c.value}</div>
            <div className="sc-bottom">
              <div className="sc-label">{c.label}</div>
              <div className="sc-note">{c.note}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Cards;
